import { OPS_EXTERNAL_INTERACTIONS_SERVICE_URL } from '@/common/config'
import { logger } from '@/services/logger/loggers'
import { OrgType } from '@sennder/senn-node-microfrontend-interfaces'
import { getStateCallbacks } from '@/store/getters'

class OpsExternalInteractionsService {
  async getCommonHeaders() {
    const commonHeaders = await getStateCallbacks().getCommonHeaders()
    if (!commonHeaders) {
      throw new Error(
        '[OpsExternalInteractions]: Error getting v4 common headers'
      )
    }
    return {
      'Content-Type': 'application/json',
      ...(commonHeaders as {
        Authorization: string
        'X-Org-Type': OrgType
        'X-Org-Id': string
      }),
    }
  }

  async sendFastPayEmail(carrierName: string): Promise<void> {
    const url = `${OPS_EXTERNAL_INTERACTIONS_SERVICE_URL}/api/v1/fast-pay-email/send`

    const response = await fetch(url, {
      method: 'POST',
      headers: await this.getCommonHeaders(),
      body: JSON.stringify({ name: carrierName }),
    })

    if (!response.ok) {
      logger.error(
        `Error sending fast pay email for carrier ${carrierName}: ${response.statusText}`,
        {}
      )
      throw new Error(
        `[OpsExternalInteractions]: sendFastPayEmail response status code: ${response.status}, status text: ${response.statusText}`
      )
    }
  }
}

export default new OpsExternalInteractionsService()
